import React from "react";
import { catalog } from "../mock";

export default function BuySection() {
  return (
    <section id="buy" data-testid="buy-section" className="home-section" style={{ background: "var(--paper)", scrollMarginTop: 120 }}>
      <div className="container">
        <div className="reveal mx-auto max-w-[780px] text-center">
          <p className="eyebrow centered">Buy pre-owned products</p>
          <h2 data-testid="buy-section-heading" className="mt-3 font-heading font-extrabold leading-[1.08]"
              style={{ color: "var(--green-950)", fontSize: "clamp(28px,3.6vw,42px)" }}>
            Practical equipment sourcing for offices, resellers &amp; projects
          </h2>
          <p className="mt-4 text-[17px]" style={{ color: "var(--muted)" }}>
            Buy working-condition pre-owned IT assets and office electronics for replacement stock, branch
            setup, resale or budget-conscious procurement.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
          {catalog.map((c, i) => {
            const Icon = c.icon;
            return (
              <article key={c.label} data-testid={`equipment-category-card-${i}`}
                       className="reveal group flex flex-col items-center justify-center gap-3 rounded-xl border bg-white px-4 py-6 text-center transition-all hover:-translate-y-1 hover:border-[color:var(--orange-500)]"
                       style={{ transitionDelay: `${i * 35}ms`, borderColor: "var(--line)", boxShadow: "0 8px 20px rgba(45,106,79,0.06)" }}>
                <span className="grid h-11 w-11 place-items-center rounded-lg transition-colors"
                      style={{ background: "rgba(232,80,26,0.10)", color: "#E8501A" }}>
                  <Icon size={22} />
                </span>
                <span className="font-heading text-[14.5px] font-bold" style={{ color: "var(--green-950)" }}>{c.label}</span>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
